var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './button.module.css';
import clsx from 'clsx';
import styles from './button.module.css';
import Icon from '../../media/icon/Icon';
export var Button = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'outline' : _b, _c = _a.size, size = _c === void 0 ? 'm' : _c, _d = _a.radius, radius = _d === void 0 ? 'soft' : _d, leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, label = _a.label, _e = _a.full, full = _e === void 0 ? false : _e, props = __rest(_a, ["type", "size", "radius", "leftIcon", "rightIcon", "label", "full"]);
    return (_jsxs("button", __assign({ type: "button", className: clsx(styles.button, styles["button__".concat(size)], styles["buttonRadius__".concat(radius)], styles["button__".concat(type)], full && styles.buttonFull, leftIcon || rightIcon ? styles['button__icon'] : null, leftIcon && styles['button__iconLeft'], rightIcon && styles['button__iconRight']) }, props, { children: [leftIcon !== undefined && _jsx(Icon, { icon: leftIcon }), label, rightIcon !== undefined && _jsx(Icon, { icon: rightIcon })] })));
};
export default Button;
